import { Stack } from '@mantine/core';
import { useRef } from 'react';
import { useDeepCompareEffect } from 'react-use';
import i18n from '../../../../../base-dictionary';
import { useFocusTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setFocusMetric,
  setFocusSelectedBoards,
  setFocusSelectedTeams,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { MAX_SELECTION } from '../../initiative-performance.constants';
import { useContributingBoards, useContributingTeams } from '../../initiative-performance.hooks';
import { FocusChart } from './focus-chart';
import { hasFocusData } from './focus-chart.helpers';
import { useFocusData, useSelection } from './focus-chart.hooks';

export const MainSection = () => {
  const metric = useFocusTabStore((state) => state.metric);
  const focusData = useFocusData();
  const selection = useSelection();
  const contributingTeams = useContributingTeams();
  const contributingBoards = useContributingBoards();

  useDeepCompareEffect(() => {
    if (contributingTeams.length > 0) {
      setFocusSelectedTeams(contributingTeams.slice(0, MAX_SELECTION));
    }
  }, [contributingTeams]);

  useDeepCompareEffect(() => {
    if (contributingBoards.length > 0) {
      setFocusSelectedBoards(contributingBoards.slice(0, MAX_SELECTION));
    }
  }, [contributingBoards]);

  const chartRef = useRef<HTMLDivElement>(null!);

  return (
    <Stack h="100%" style={{ overflow: 'hidden' }}>
      <MainSectionControls
        title={i18n.t('strategy.initiative_performance.focus')}
        chartRef={chartRef}
        metric={metric}
        setMetric={setFocusMetric}
        disableControls={!hasFocusData(focusData) || selection.length === 0}
      />
      <FocusChart chartRef={chartRef} />
    </Stack>
  );
};
